import './driversDetailSummary.css';
import Placeholder from "../../../shared/placeholder/placeholder";

const DriversDetailSummary = ({summary, distanceLoader = false, summaryLoader = false}) => {
    return (
        <>
        <ul className={'driver-summary flex hr-space-between align-top gap-10'}>
                {/* <li className="distance">
                    <div className={'number light-color sf-bold'}><span className={'green-color'}>30k</span>/28k</div>
                    <div className="name sf-medium">Kms Travelled</div>
                </li> */}
                {/* {!distanceLoader &&
                    <li className="counts">
                        <div className={'number light-color sf-bold'}><span className={'green-color'}>
                    {summary?.counts?.currentPeriod?.count}</span>/{summary?.counts?.lastPeriod?.count}
                        </div>
                        <div className="name sf-medium">Trips</div>
                    </li>
                } */}
                {distanceLoader &&
                    <li className={'round-corner-8'}><Placeholder width={'140px'} height={'75px'}/></li>
                }
                {!summaryLoader && summary?.alerts?.length > 0 && 
                    summary?.alerts?.map((alert, index) =>
                        (alert?.value &&
                            <li key={alert.id} className="alert">
                                <div
                                    className={`number sf-medium ${alert?.value > 10 ? 'red-color' : 'green-color'}`}>{alert?.value}</div>
                                <div className="name sf-medium">{alert['tooltip_name']}</div>
                            </li>
                        )
                    )
                }
                {summaryLoader &&
                    [1, 2, 3, 4, 5].map((index) =>
                    <li key={index} className={'round-corner-8'}><Placeholder width={'140px'} height={'75px'}/></li>
                )}

            </ul>
        </>
    )
}

export default DriversDetailSummary;
